const CHANGE_PASSWORD_ACTION = 'CHANGE_PASSWORD_ACTION'
const CHANGE_PASSWORD_ACTION_SUCCESS = 'CHANGE_PASSWORD_ACTION_SUCCESS'
const CHANGE_PASSWORD_ACTION_SUCCESS_RESET = 'CHANGE_PASSWORD_ACTION_SUCCESS_RESET'

export {
  CHANGE_PASSWORD_ACTION,
  CHANGE_PASSWORD_ACTION_SUCCESS,
  CHANGE_PASSWORD_ACTION_SUCCESS_RESET,
}
